<script>
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrIsoIcTetkik from "@/models/StrIsoIcTetkik";
export default {
  mixins: [Api, Sabit, StrIsoIcTetkik],
  props: ["Tetkik"],
  data() {
    return {
      TableData: [],
      No: null,
      Soru: null,
      FormData: null,
      Uygunsuzluk: {
        No: 1,
        Duzey: "",
        Tanim: "",
        Iyilesirme: "",
        OnGorulenIyilestirmeTarihi: ""
      },
      GelisimeAcikYon: {
        Gozlem: "",
        Iyilesirme: "",
      },
      KuvvetliYon: {
        Gozlem: "",
      }
    };
  },
  components: {
    Loader
  },
  watch: {
    Tetkik() {
      this.FormData = this.Tetkik;
      if (this.FormData) {
        if (typeof this.FormData.Uygunsuzluklar === 'string') {
          this.FormData.Uygunsuzluklar = JSON.parse(this.FormData.Uygunsuzluklar)
          this.FormData.Gelisimeacikyonler = JSON.parse(this.FormData.Gelisimeacikyonler)
          this.FormData.Kuvvetliyonler = JSON.parse(this.FormData.Kuvvetliyonler)
        }
      }
    },
  },
  methods: {
    Get() { },
    UygunsuzlukAdd() {
      this.FormData.Uygunsuzluklar.push({ ...this.Uygunsuzluk })
    },
    UygunsuzlukDelete(index) {
      this.FormData.Uygunsuzluklar.splice(index, 1);
    },
    GelisimeAcikYonAdd() {
      this.FormData.Gelisimeacikyonler.push({...this.GelisimeAcikYon})
    },
    GelisimeAcikYonDelete(index) {
      this.FormData.Gelisimeacikyonler.splice(index, 1);
    },
    KuvvetliYonAdd() {
      this.FormData.Kuvvetliyonler.push({ ...this.KuvvetliYon})
    },
    KuvvetliYonDelete(index) {
      this.FormData.Kuvvetliyonler.splice(index, 1);
    },

    onSubmit() {
      this.FormData.Uygunsuzluklar = JSON.stringify(this.FormData.Uygunsuzluklar)
      this.FormData.Gelisimeacikyonler = JSON.stringify(this.FormData.Gelisimeacikyonler)
      this.FormData.Kuvvetliyonler = JSON.stringify(this.FormData.Kuvvetliyonler)
      this.Update("StrIsoIcTetkik", this.FormData).then((res) => {
        if (res) {
          this.FormData.Uygunsuzluklar = JSON.parse(this.FormData.Uygunsuzluklar)
          this.FormData.Gelisimeacikyonler = JSON.parse(this.FormData.Gelisimeacikyonler)
          this.FormData.Kuvvetliyonler = JSON.parse(this.FormData.Kuvvetliyonler)
        }
      });


    },
  },
};
</script>
<template>
  <Loader>
    <b-modal id="StrIsoIcTetkikSonuc" size="lg" title="İÇ TETKİK SONUÇLARI" title-class="font-18" hide-footer>

      <Form @submit.prevent="onSubmit">
        <div class="row" v-if="FormData">




          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="table">
                <tr>
                  <th colspan="6" class="text-center"> TESPİT EDİLEN UYGUNSUZLUKLAR </th>
                </tr>
                <tr>
                  <th>Soru No</th> 
                  <th v-if="0">Düzey</th>
                  <th>Uygunsuzluk Tanımı </th>
                  <th>Beklenen İyileştirme</th>
                  <th>Öngörülen İyileştirme Tarihi</th>
                  <th>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th> <b-form-input v-model="Uygunsuzluk.No" type="number"></b-form-input> </th> 
                  <th  v-if="0"><b-form-input v-model="Uygunsuzluk.Duzey"></b-form-input> </th>
                  <th><b-form-input v-model="Uygunsuzluk.Tanim"></b-form-input> </th>
                  <th> <b-form-input v-model="Uygunsuzluk.Iyilesirme"></b-form-input></th>
                  <th> <b-form-input v-model="Uygunsuzluk.OnGorulenIyilestirmeTarihi" type="date"></b-form-input></th>
                  <th> <button class="btn btn-primary " style="height: 40px;" type="button" @click="UygunsuzlukAdd()">
                      Kaydet
                    </button></th>
                </tr>
                <tr v-for="(Data, index) in FormData.Uygunsuzluklar" :key="index">
                  <th scope="row">{{ Data.No }}</th>
                  <td v-if="0">{{ Data.Duzey }}</td>
                  <td>{{ Data.Tanim }}</td>
                  <td>{{ Data.Iyilesirme }}</td>
                  <td>{{ Data.OnGorulenIyilestirmeTarihi }}</td>
                  <td>
                    <div class="action-is w-100 d-flex justify-content-center align-items-center">
                      <i class="fas fa-trash-alt" @click="UygunsuzlukDelete(index)"></i>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>



          <div class="table-responsive mt-5">
            <table class="table mb-0">
              <thead class="table">
                <tr>
                  <th colspan="6" class="text-center"> GELİŞİME AÇIK YÖNLER </th>
                </tr>
                <tr>
                  <th>Gözlem</th>
                  <th>Beklenen İyileştirme</th>
                  <th>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th><b-form-input v-model="GelisimeAcikYon.Gozlem"></b-form-input> </th>
                  <th> <b-form-input v-model="GelisimeAcikYon.Iyilesirme"></b-form-input></th>
                  <th> <button class="btn btn-primary " style="height: 40px;" type="button"
                      @click="GelisimeAcikYonAdd()">
                      Kaydet
                    </button></th>
                </tr>
                <tr v-for="(Data, index) in FormData.Gelisimeacikyonler" :key="index">
                  <th scope="row">{{ Data.Gozlem }}</th>
                  <td>{{ Data.Iyilesirme }}</td>
                  <td>
                    <div class="action-is w-100 d-flex justify-content-center align-items-center">
                      <i class="fas fa-trash-alt" @click="GelisimeAcikYonDelete(index)"></i>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>



          <div class="table-responsive  mt-5">
            <table class="table mb-0">
              <thead class="table">
                <tr>
                  <th colspan="6" class="text-center"> KUVVETLİ YÖNLER </th>
                </tr>
                <tr>
                  <th>Gözlem</th>
                  <th>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th><b-form-input v-model="KuvvetliYon.Gozlem"></b-form-input> </th>
                  <th> <button class="btn btn-primary " style="height: 40px;" type="button" @click="KuvvetliYonAdd()">
                      Kaydet
                    </button></th>
                </tr>
                <tr v-for="(Data, index) in FormData.Kuvvetliyonler" :key="index">
                  <th scope="row">{{ Data.Gozlem }}</th>
                  <td>
                    <div class="action-is w-100 d-flex justify-content-center align-items-center">
                      <i class="fas fa-trash-alt" @click="KuvvetliYonDelete(index)"></i>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <button class="btn btn-primary mt-3" type="submit">
          Kaydet
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
